export default __webpack_public_path__ + "media/images/user_photos/26-17422e7adab7d1bcf8583e2022e65792.jpg";